var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss3Original(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_102_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8138 114.123L8.75977 1.35156H119.24L109.176 114.106L63.9328 126.649L18.8138 114.123V114.123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.001 117.062L100.56 106.926L109.161 10.5723H64.001V117.062Z",
    fill: "#323330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.001 51.4286H82.303L83.567 37.2656H64.001V23.4346H98.683L98.351 27.1456L94.951 65.2596H64.001V51.4286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.083 87.3488L64.022 87.3668L48.619 83.2078L47.634 72.1768H33.752L35.689 93.8938L64.02 101.757L64.083 101.739V87.3488V87.3488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.127 64.675L79.461 83.197L64.035 87.361V101.751L92.389 93.893L92.597 91.556L95.003 64.675H81.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0479 23.4346V37.2656H30.6399L30.3629 34.1576L29.7329 27.1456L29.4019 23.4346H64.0479V23.4346ZM64.0009 51.4306V65.2616H48.7919L48.5149 62.1536L47.8839 55.1416L47.5539 51.4306H64.0009V51.4306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_102_35",
    x: -4,
    y: -4,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_102_35"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_102_35",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3Original);
export default __webpack_public_path__ + "static/media/css3-original.029b372bcd39127d435d2d1b337a7a7b.svg";
export { ForwardRef as ReactComponent };